import { TItemType } from '../PlayerListItem';
import { isAward } from './isAward';
import { isEventEnrollment } from './isEventEnrollment';
import { isPlayer } from './isPlayer';

export const getUserFullname = (item: TItemType): string => {
  if (isPlayer(item)) {
    return `${item.firstName} ${item.lastName}`;
  }

  if (isEventEnrollment(item)) {
    return `${item.user.firstName} ${item.user.lastName}`;
  }

  if (isAward(item)) {
    const firstAward = item.awards[0];

    return firstAward ? `${firstAward.userFirstName} ${firstAward.userLastName}` : '';
  }

  return '';
};
